export default __webpack_public_path__ + "static/media/sad_icon.3de3506c.svg";